
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import _export from '../internals/export.js';
import arrayFill from '../internals/array-fill.js';
import addToUnscopables$1 from '../internals/add-to-unscopables.js';

var $ = _export;
var fill = arrayFill;
var addToUnscopables = addToUnscopables$1;

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');
//# sourceMappingURL=es.array.fill.js.map
